import React from "react";

export interface PlotGridProps {
  children: React.ReactNode;
  className?: string;
  columns?: 1 | 2;
}

const PlotGrid = ({ children, className = "", columns = 2 }: PlotGridProps) => (
  <div
    className={`grid gap-4 w-full items-start ${className}`}
    style={{
      gridTemplateColumns:
        columns === 2
          ? "repeat(auto-fit, minmax(min(100%, 400px), 1fr))"
          : "minmax(0, 1fr)",
    }}
  >
    {React.Children.map(children, (child) =>
      child ? (
        <div
          className="w-full min-w-0 rounded-xl border border-slate-200 bg-white p-3 shadow-sm overflow-hidden"
          style={{ minHeight: 320 }}
        >
          {child}
        </div>
      ) : null,
    )}
  </div>
);

export default PlotGrid;
